import { useCallback, useEffect, useState } from 'react';

// Toast notification state shared by both apps.
export const useNotification = () => {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback((message, type = 'error') => {
    setNotification({ message, type });
  }, []);

  const dismiss = useCallback(() => setNotification(null), []);

  useEffect(() => {
    if (!notification) return undefined;
    const t = window.setTimeout(() => setNotification(null), 3200);
    return () => window.clearTimeout(t);
  }, [notification]);

  return { notification, showNotification, dismiss };
};
